export class Sort {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
}

export class Pageable {
    sort: Sort;
    offset: number;
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    unpaged: boolean;
}

export class PageData {
    pageable: Pageable;
    sort: Sort;
    last: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    number: number;
    first: boolean;
    numberOfElements: number;
    empty: boolean;
}
